import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";
import axios from "axios";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { setSession } from "@/lib/sessionStore";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
        { email, password },
      );
      if (data.user.role !== "super_admin") {
        toast.error("Esta área é exclusiva para administradores AgentUS.");
        setLoading(false);
        return;
      }
      localStorage.setItem("agentos_token", data.token);
      setSession({ token: data.token, user: data.user, tenant: data.tenant });
      navigate("/admin-master");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const status = err?.response?.status;
      let msg = "Não foi possível entrar. Tente novamente.";
      if (status === 401) {
        msg = "Credenciais inválidas";
      } else if (typeof detail === "string" && detail) {
        msg = detail;
      }
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center p-6 font-body text-slate-100">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-10">
          <div className="w-9 h-9 rounded-md bg-white/10 flex items-center justify-center">
            <ShieldCheck size={18} weight="regular" className="text-white" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-medium">AgentUS</div>
            <div className="font-heading text-base font-semibold tracking-tight leading-none">Admin Master</div>
          </div>
        </div>

        <h1 className="font-heading text-3xl font-semibold tracking-tight">Acesso da plataforma</h1>
        <p className="text-slate-400 text-sm mt-2 leading-relaxed">
          Console exclusivo do dono da plataforma. Acesse para gerenciar tenants, custos de IA e operação SaaS.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-[11px] uppercase tracking-[0.16em] text-slate-400 font-medium mb-2">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full px-3.5 py-2.5 bg-white/5 border border-white/10 rounded-md text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-white/30 transition-colors"
              placeholder="master@agentus.com.br"
            />
          </label>
          <label className="block">
            <span className="block text-[11px] uppercase tracking-[0.16em] text-slate-400 font-medium mb-2">Senha</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full px-3.5 py-2.5 bg-white/5 border border-white/10 rounded-md text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-white/30 transition-colors"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full mt-2 inline-flex items-center justify-center gap-2 bg-white text-slate-900 px-4 py-2.5 rounded-md text-sm font-semibold hover:bg-slate-200 transition-colors disabled:opacity-60"
          >
            {loading ? "Entrando…" : "Entrar"} <ArrowRight size={14} weight="regular" />
          </button>
        </form>

        <p className="text-[11px] text-slate-600 mt-8 leading-relaxed">
          Acesso restrito. Todas as ações são auditadas e ficam registradas no log de eventos da plataforma.
        </p>
      </div>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}
